import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";
import PortfolioGrid from "@/sections/PortfolioGrid";
import CTABanner from "@/components/CTABanner";

export default function PortfolioPage() {
  return (
    <>
      <SEO
        title="Portfolio — Our Work"
        description="Explore DiziTeQ's portfolio of premium websites, branding and marketing campaigns delivered for Bengaluru businesses across every industry."
        path="/portfolio"
      />
      <PageHeader
        eyebrow="Portfolio"
        title="Premium work that"
        highlight="drives growth"
        subtitle="A selection of the websites, brands and campaigns we've crafted. Filter by category to explore."
      />
      <PortfolioGrid withFilters showHeader={false} />
      <div className="py-10"><CTABanner /></div>
    </>
  );
}
